import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles((theme) => ({

  inputStatus: {
    fontSize: 12,
    fontWeight: 'bold',
    color: ({ infoType }) => {
      switch (infoType) {
        case 'success':
          return 'green';
        case 'warning':
          return 'orange';
        case 'error':
          return 'red';
        default:
          return 'gray';
      }
    },
  },
  inputStatusSuccess: {
    color: 'green',
  },
  inputStatusWarning: {
    color: 'orange',
  },
  inputStatusIcon: {

    marginInlineEnd: theme.spacing(0.5),
  },
  asterisk: {
    color: '#ef5350',
  },
}));
